import RegistrationViewHandler from './RegistrationViewHandler';

export default RegistrationViewHandler;
